// Mock data for the website (bilingual: ar / en)

export const learningPaths = [
  {
    id: 'plc-beginners',
    title: { ar: 'مسار PLC للمبتدئين', en: 'PLC Path for Beginners' },
    desc: { ar: 'ابدأ من الأساسيات وتعلم برمجة PLC باحتراف', en: 'Start from basics and learn PLC programming professionally' },
    level: { ar: 'المستوى - مبتدئ - متوسط', en: 'Level: Beginner - Intermediate' },
    courses: 4,
    color: 'blue',
    steps: [
      { ar: 'أساسيات الكهرباء', en: 'Electrical Basics' },
      { ar: 'PLC S7-1200', en: 'PLC S7-1200' },
      { ar: 'مشاريع عملية', en: 'Practical Projects' }
    ]
  },
  {
    id: 'scada-path',
    title: { ar: 'مسار SCADA', en: 'SCADA Path' },
    desc: { ar: 'تعلم أنظمة SCADA والتطبيقات العملية', en: 'Learn SCADA systems and practical applications' },
    level: { ar: 'المستوى - متوسط', en: 'Level: Intermediate' },
    courses: 3,
    color: 'purple',
    steps: [
      { ar: 'أساسيات SCADA', en: 'SCADA Basics' },
      { ar: 'WinCC', en: 'WinCC' },
      { ar: 'مشاريع وتطبيقات', en: 'Projects & Applications' }
    ]
  },
  {
    id: 'robotics-path',
    title: { ar: 'مسار روبوتات صناعية', en: 'Industrial Robotics Path' },
    desc: { ar: 'تعلم برمجة وتشغيل الروبوتات الصناعية خطوة بخطوة', en: 'Learn programming and operating industrial robots step by step' },
    level: { ar: 'المستوى - متوسط - متقدم', en: 'Level: Intermediate - Advanced' },
    courses: 5,
    color: 'green',
    steps: [
      { ar: 'برمجة ABB', en: 'ABB Programming' },
      { ar: 'برمجة ABB', en: 'ABB Programming' },
      { ar: 'التكامل والتطبيقات', en: 'Integration & Applications' }
    ]
  }
];

export const stats = [
  { value: '+15K', key: 'students' },
  { value: '+70', key: 'courses' },
  { value: '+120', key: 'hours' },
  { value: '+500', key: 'projects' }
];

export const testimonials = [
  {
    id: 't1',
    name: { ar: 'محمد السبيعي', en: 'Mohammed Al-Subaie' },
    role: { ar: 'مهندس تحكم', en: 'Control Engineer' },
    text: {
      ar: 'الكورسات ممتازة والشرح مبسط جداً. استفدت من دورة S7-1200 وطبقت مشاريع رائعة في عملي.',
      en: 'Excellent courses with simple explanation. I benefited from S7-1200 course and applied great projects at work.'
    },
    avatar: 'https://i.pravatar.cc/100?img=12',
    rating: 5
  },
  {
    id: 't2',
    name: { ar: 'أحمد خالد', en: 'Ahmed Khaled' },
    role: { ar: 'فني صيانة', en: 'Maintenance Technician' },
    text: {
      ar: 'من أفضل المنصات العربية في مجال الأتمتة. المحتوى عملي والدعم مميز جداً.',
      en: 'One of the best Arabic platforms in automation. Practical content and excellent support.'
    },
    avatar: 'https://i.pravatar.cc/100?img=33',
    rating: 5
  },
  {
    id: 't3',
    name: { ar: 'ياسر الحميدي', en: 'Yasser Al-Hamidi' },
    role: { ar: 'مهندس اتصالات', en: 'Communications Engineer' },
    text: {
      ar: 'تعلمت SCADA من الصفر وأصبح لدي خبرة عملية قوية بفضل المشاريع والتطبيقات.',
      en: 'I learned SCADA from scratch and now I have strong practical experience thanks to projects and applications.'
    },
    avatar: 'https://i.pravatar.cc/100?img=15',
    rating: 5
  },
  {
    id: 't4',
    name: { ar: 'سارة العتيبي', en: 'Sara Al-Otaibi' },
    role: { ar: 'مهندسة كهرباء', en: 'Electrical Engineer' },
    text: {
      ar: 'المنصة غيّرت مساري المهني، الكورسات منظمة والشرح يصل بسهولة حتى للمبتدئين.',
      en: 'This platform changed my career path. Well-organized courses and easy explanations even for beginners.'
    },
    avatar: 'https://i.pravatar.cc/100?img=47',
    rating: 5
  },
  {
    id: 't5',
    name: { ar: 'عبدالله القحطاني', en: 'Abdullah Al-Qahtani' },
    role: { ar: 'مهندس أتمتة صناعية', en: 'Industrial Automation Engineer' },
    text: {
      ar: 'استفدت كثيراً من دورات HMI و WinCC. الأمثلة عملية ومرتبطة بسوق العمل.',
      en: 'I greatly benefited from HMI and WinCC courses. Practical examples directly related to the job market.'
    },
    avatar: 'https://i.pravatar.cc/100?img=68',
    rating: 5
  },
  {
    id: 't6',
    name: { ar: 'خالد الزهراني', en: 'Khalid Al-Zahrani' },
    role: { ar: 'فني PLC', en: 'PLC Technician' },
    text: {
      ar: 'أفضل استثمار قمت به هذا العام. تعلمت برمجة Siemens TIA Portal بإحترافية.',
      en: 'Best investment I made this year. I learned Siemens TIA Portal programming professionally.'
    },
    avatar: 'https://i.pravatar.cc/100?img=52',
    rating: 5
  },
  {
    id: 't7',
    name: { ar: 'نوف الشمري', en: 'Nouf Al-Shammari' },
    role: { ar: 'طالبة هندسة', en: 'Engineering Student' },
    text: {
      ar: 'كطالبة جامعية، ساعدتني المنصّة على فهم الجانب العملي بشكل لم تقدّمه الجامعة.',
      en: 'As a student, the platform helped me grasp the practical side that university did not provide.'
    },
    avatar: 'https://i.pravatar.cc/100?img=44',
    rating: 5
  },
  {
    id: 't8',
    name: { ar: 'فهد الدوسري', en: 'Fahad Al-Dosari' },
    role: { ar: 'مدير صيانة', en: 'Maintenance Manager' },
    text: {
      ar: 'استخدمت المنصّة لتدريب فريقي بالكامل. النتائج كانت مذهلة وقلّت الأعطال.',
      en: 'I used the platform to train my entire team. Results were amazing and breakdowns decreased.'
    },
    avatar: 'https://i.pravatar.cc/100?img=60',
    rating: 5
  },
  {
    id: 't9',
    name: { ar: 'مها الحربي', en: 'Maha Al-Harbi' },
    role: { ar: 'مهندسة ميكانيك', en: 'Mechanical Engineer' },
    text: {
      ar: 'الشرح يبدأ من الأساسيات وينتهي بمشاريع متقدمة. استمتعت بكل دقيقة.',
      en: 'Lessons start from basics and end with advanced projects. I enjoyed every minute.'
    },
    avatar: 'https://i.pravatar.cc/100?img=25',
    rating: 5
  },
  {
    id: 't10',
    name: { ar: 'سعد المطيري', en: 'Saad Al-Mutairi' },
    role: { ar: 'مهندس كهرباء', en: 'Electrical Engineer' },
    text: {
      ar: 'وفّرت لي المنصّة سنوات من البحث المتفرّق. كل شيء منظّم في مكان واحد.',
      en: 'The platform saved me years of scattered research. Everything organized in one place.'
    },
    avatar: 'https://i.pravatar.cc/100?img=8',
    rating: 5
  },
  {
    id: 't11',
    name: { ar: 'ريم العنزي', en: 'Reem Al-Anazi' },
    role: { ar: 'مهندسة برمجيات', en: 'Software Engineer' },
    text: {
      ar: 'دخلت المجال الصناعي من خلفية برمجة، وسهّل عليّ المحتوى الانتقال بسلاسة.',
      en: 'I entered the industrial field from a software background; the content made the transition smooth.'
    },
    avatar: 'https://i.pravatar.cc/100?img=49',
    rating: 5
  },
  {
    id: 't12',
    name: { ar: 'بدر الجهني', en: 'Badr Al-Juhani' },
    role: { ar: 'مشرف خط إنتاج', en: 'Production Line Supervisor' },
    text: {
      ar: 'حسّنت من أداء خط الإنتاج بفضل ما تعلمته من دورات الـ HMI و SCADA.',
      en: 'I improved production line performance thanks to what I learned in HMI and SCADA courses.'
    },
    avatar: 'https://i.pravatar.cc/100?img=11',
    rating: 5
  },
  {
    id: 't13',
    name: { ar: 'لمى السهلي', en: 'Lama Al-Sahli' },
    role: { ar: 'مهندسة جودة', en: 'Quality Engineer' },
    text: {
      ar: 'المحتوى عربي 100% وبجودة عالمية. أنصح كل مهندس عربي بالاشتراك.',
      en: '100% Arabic content with global quality. I recommend every Arab engineer to subscribe.'
    },
    avatar: 'https://i.pravatar.cc/100?img=23',
    rating: 5
  },
  {
    id: 't14',
    name: { ar: 'تركي الغامدي', en: 'Turki Al-Ghamdi' },
    role: { ar: 'مهندس مشاريع', en: 'Project Engineer' },
    text: {
      ar: 'الشهادات معتمدة وفتحت لي أبواب وظيفية جديدة في شركات كبرى.',
      en: 'Certificates are accredited and opened new career doors in major companies.'
    },
    avatar: 'https://i.pravatar.cc/100?img=53',
    rating: 5
  },
  {
    id: 't15',
    name: { ar: 'هند الرشيد', en: 'Hind Al-Rasheed' },
    role: { ar: 'مهندسة أتمتة', en: 'Automation Engineer' },
    text: {
      ar: 'المجتمع داعم ومحترف، أحصل على إجابات على أسئلتي خلال دقائق.',
      en: 'Supportive professional community. I get answers to my questions within minutes.'
    },
    avatar: 'https://i.pravatar.cc/100?img=36',
    rating: 5
  },
  {
    id: 't16',
    name: { ar: 'ماجد العسيري', en: 'Majed Al-Aseeri' },
    role: { ar: 'فني تحكم آلي', en: 'Automation Technician' },
    text: {
      ar: 'تعلمت TIA Portal من البداية وأنجزت مشروع تخرّجي بثقة كاملة.',
      en: 'I learned TIA Portal from scratch and finished my graduation project with full confidence.'
    },
    avatar: 'https://i.pravatar.cc/100?img=58',
    rating: 5
  }
];

export const partners = [
  { name: 'SIEMENS', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Siemens-logo.svg/2560px-Siemens-logo.svg.png' },
  { name: 'Schneider', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Schneider_Electric_2007.svg/2560px-Schneider_Electric_2007.svg.png' },
  { name: 'ABB', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/ABB_logo.svg/2560px-ABB_logo.svg.png' },
  { name: 'Rockwell', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Rockwell_Automation_logo.svg/2560px-Rockwell_Automation_logo.svg.png' },
  { name: 'Mitsubishi', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Mitsubishi_Electric_logo.svg/2560px-Mitsubishi_Electric_logo.svg.png' },
  { name: 'OMRON', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/OMRON_Logo.svg/2560px-OMRON_Logo.svg.png' }
];

export const heroImage = 'https://images.pexels.com/photos/18471441/pexels-photo-18471441.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';

export const posts = [
  {
    id: 'p1',
    title: { ar: 'مقدمة في برمجة PLC', en: 'Introduction to PLC Programming' },
    excerpt: { ar: 'تعرف على أساسيات PLC وكيفية بدء البرمجة من الصفر', en: 'Learn the basics of PLC and how to start programming from scratch' },
    cover: 'https://images.pexels.com/photos/8438967/pexels-photo-8438967.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600',
    date: '2025-06-15',
    author: { ar: 'فريق Automeet Network', en: 'Automeet Network Team' }
  },
  {
    id: 'p2',
    title: { ar: 'الفرق بين PLC وأنظمة DCS', en: 'PLC vs DCS Systems' },
    excerpt: { ar: 'مقارنة شاملة بين أنظمة التحكم PLC و DCS وأيهما الأنسب لتطبيقاتك', en: 'A comprehensive comparison between PLC and DCS control systems' },
    cover: 'https://images.unsplash.com/photo-1697071612388-1d1a86fb8cc1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxQTEMlMjBjb250cm9sbGVyJTIwaW5kdXN0cmlhbHxlbnwwfHx8fDE3NzczMTEwNjh8MA&ixlib=rb-4.1.0&q=85',
    date: '2025-05-22',
    author: { ar: 'فريق Automeet Network', en: 'Automeet Network Team' }
  },
  {
    id: 'p3',
    title: { ar: 'مستقبل الروبوتات الصناعية', en: 'Future of Industrial Robotics' },
    excerpt: { ar: 'كيف ستغير الروبوتات الصناعية مستقبل المصانع وخطوط الإنتاج', en: 'How industrial robots will change the future of factories and production lines' },
    cover: 'https://images.pexels.com/photos/34207359/pexels-photo-34207359.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600',
    date: '2025-04-10',
    author: { ar: 'فريق Automeet Network', en: 'Automeet Network Team' }
  }
];

export const subscriptionFeatures = [
  { icon: 'BookOpen', title: { ar: 'وصول كامل لجميع الكورسات', en: 'Full access to all courses' }, desc: { ar: '+70 كورس احترافي في الأتمتة الصناعية', en: '+70 professional courses in industrial automation' } },
  { icon: 'Download', title: { ar: 'تحميل المحتوى', en: 'Downloadable content' }, desc: { ar: 'حمّل الفيديوهات والملفات والملخصات', en: 'Download videos, files and summaries' } },
  { icon: 'Award', title: { ar: 'شهادة إنجاز معتمدة', en: 'Certified completion certificate' }, desc: { ar: 'احصل على شهادة عند إكمال كل دورة', en: 'Get a certificate upon completing each course' } },
  { icon: 'Users', title: { ar: 'مجتمع خاص ودعم فني', en: 'Private community & support' }, desc: { ar: 'تواصل مع المدربين والطلاب', en: 'Connect with trainers and students' } },
  { icon: 'Briefcase', title: { ar: 'مشاريع حقيقية', en: 'Real projects' }, desc: { ar: 'مشاريع عملية من سوق العمل', en: 'Practical projects from the job market' } },
  { icon: 'Rocket', title: { ar: 'تحديثات دورية', en: 'Periodic updates' }, desc: { ar: 'كورسات جديدة باستمرار', en: 'New courses added continuously' } }
];
